export default function loadDisclosureBanner() {
  const banner = document.getElementById('ftc-disclosure-organic-banner');

  if (!banner) {
    return;
  }

  import('./disclosure-banner')
    .then(({ default: initDisclosureBanner }) => initDisclosureBanner(banner))
    .catch((err) => {
      console.error('Failed to load disclosure-banner module:', err);
    });
}
